import * as React from "react"
import { styled } from "@mui/material/styles"
import Grid from "@mui/material/Grid"
// import Paper from "@mui/material/Paper"
import Box from "@mui/material/Box"
import { Routes, Link, Route, BrowserRouter } from "react-router-dom"
import { Card, CardActions, CardContent, Typography } from "@mui/material"
// import ResourcesGrid from "../../features/resources-grid/ResourcesGrid"
// import ResourcesCategories from "../../features/resources-categories/ResourcesCategories"
// import { alignProperty } from "@mui/material/styles/cssUtils"

export default function ResourcesLayout() {
  return (
    <Box
      sx={{
        width: "90%",
        mx: "auto",
      }}
    >
      <Grid
        container
        spacing={6}
        sx={{
          margin: "auto",
        }}
      >
        <Grid item xs={11}>
          <Card
            sx={{
              margin: "auto",
              width: "90%",
              padding: "20px",
              borderRadius: "20px",
              backgroundColor: "#F8F3ED80",
              boxShadow: "0 0px 20px 0px #bfbfbf",
              mb: 3,
            }}
          >
            <CardContent sx={{ textAlign: "center" }}>
              <Typography
                variant="body1"
                sx={{ mx: "6%", fontSize: "21px", my: "1.75%" }}
              >
                Our Volunteers and case workers are knowledgeable in many areas
                of personal and professional support. If you require assistance
                with housing, food, or other social services, please complete
                our contact us form and we will respond to your request.
              </Typography>
            </CardContent>
            <CardActions sx={{ mb: "2.5%" }}>
              <Link to="/contact-us" className="home-check-button">
                Contact Us
              </Link>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}
